import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatSort, Sort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, debounceTime, distinctUntilChanged, map, startWith} from 'rxjs';
import {ContainerPickup} from 'src/app/models/container-pickup';
import {ContainerInfo, DoContainerReference} from 'src/app/models/do-container-reference';
import {ApiRoutes} from 'src/app/services/apiroutes';
import {DomainCodeApiService} from 'src/app/services/domain_code/domain-code-api.service';
import {RequestApiService} from 'src/app/services/domain_code/request-api.service';
import {ReleaseOrderService} from 'src/app/services/release-order.service';
import {
    SupplierPickupReturnContainersComponent
} from '../supplier-pickup-return-containers/supplier-pickup-return-containers.component';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from 'src/app/services/auth.service';
import {ContainerlistforpickupComponent} from '../containerlistforpickup/containerlistforpickup.component';
import {WarningBoxComponent} from '../../dialog-box/warning-box/warning-box.component';
import {RequestDetailsBookingChargesService} from "../../../services/request-details-booking-charges.service";

@Component({
    selector: 'logzy-pickup-return',
    templateUrl: './pickup-return.component.html',
    styleUrls: ['./pickup-return.component.scss']
})
export class PickupReturnComponent implements OnInit {
    isCustomer: boolean = this.authService.isCustomer();
    depotSeleted: boolean = false;
    markedPickup: boolean = false;
    PickupContainer: boolean = false;
    firstPick: boolean = true;
    review: boolean = false;
    pickupData: boolean = false;
    set1: boolean = false;
    billuLoader: boolean = true;
    part1: string = 'Just';
    part2: string = 'Checking';
    part3: string = 'data';
    showPickup: boolean = true;
    Canvas: string = "Canvas";
    open: string = "sidepanel";
    matColor: string = "darken";
    containerSwapWith: string;
    ContainerReference: any;
    releaseOrder: any;
    refID: any
    releaseService: ReleaseOrderService;
    container_nums: string;
    pick_up: Date;
    remark: string;
    disableDate: false;
    errorObj: any = {};
    containerPickupResponse;
    containerID: any;
    containerPickupData: any;
    isEditable: boolean = false;
    swapContainer: boolean = false;
    // postPickup:boolean = false
    currentDate = new Date();
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    displayedColumns: string[] = ['container', 'container_size_type', 'do_reference_no', 'pickup_depot', 'ownership', 'pickup_date', 'user_remark','swap_remark', 'actions'];
    pickupList: MatTableDataSource<ContainerPickup>;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchTerm = '';
    cardLoader: boolean = true;

    searchText = new BehaviorSubject<string>('');

    containerInfo: ContainerInfo[] = [];

    transactionType: string = '';
    requestType: string = '';

    disableValidateContainers: boolean = false;
    selectedContainers: string[] = [];
    // selectedContainers: any;
    //
    @ViewChild(ContainerlistforpickupComponent) containersListComponent!: ContainerlistforpickupComponent;

    @Input() loading: boolean = false;

    @Output() navigatePickUp = new EventEmitter<any>();
    requestId: any;
    port_url = ApiRoutes.DepotMaster;
    ports_url:any;

    constructor(public releaseservice: ReleaseOrderService, private snackBar: MatSnackBar,
                public requestService: RequestApiService, public authService: AuthService,
                private route: ActivatedRoute, private domainService: DomainCodeApiService,
                private router: Router, private dialog: MatDialog,
                public requestDetailsBookingChargesService: RequestDetailsBookingChargesService
    ) {
    }


    defaultPickup: any;
    pickupObject: DoContainerReference = {
        id: null,
        is_active: true,
        charged_from: null,
        charged_to: null,
        // current_status: null,
        system_remarks: null,
        user_remark: null,
        is_invoiced: true,
        type: null,
        pickup_date: null,
        transporter_name: null,
        truck_no: null,
        do: null,
        container: null,
        invoice_number: null,
        invoice_date: null
    }
    defaultContainer: any;
    containerPickup: ContainerPickup = {
        id: null,
        container_numbers: null,
        do: null,
        pickup_date: null,
        remarks: null,
        port:null,
        invoice_number:null,
        invoice_date:null,

    }

    ngOnInit(): void {
        this.releaseService = this.releaseOrder;
        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getReleaseorderbyReqID(params['id']);
                this.getContainerPickupbyReqId(params['id']);
                // this.getAllContainerPickup(params['id']);
                this.refreshPickupList(params['id'])
                this.requestId = params['id']
            }

            if ('type' in params) {
                this.transactionType = params['type'];
            }

            if ('rtype' in params) {
                this.requestType = params['rtype'];
            }
        });

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.refreshPickupList(this.releaseservice?.selectedOrder?.id, this.pageSize, this.pageIndex, searchText);
            })
        ).subscribe();

        if (this.isCustomer && this.requestService?.selectedRequest?.transaction_type == 'use') {
            this.displayedColumns = ['container', 'container_size_type', 'do_reference_no', 'pickup_depot', 'ownership', 'pickup_date', 'user_remark','swap_remark'];
        } else {
            this.displayedColumns = ['container', 'container_size_type', 'do_reference_no', 'pickup_depot', 'ownership', 'pickup_date', 'user_remark','swap_remark', 'actions'];
        }
    }

    ngAfterViewInit() {
        if (this.pickupList != null || this.pickupList != undefined) {
            this.pickupList.paginator = this.paginator;
            this.pickupList.sort = this.sort;
        }
    }

    selectedDepot() {
        this.depotSeleted = true;
    }

    selectDO: any;
    pickupId: any;

    select(item) {
        if (item.remaining_pickup_quantity) {
            this.pickupData = true;
            this.selectDO = {...item};
            console.log("selected DO", this.selectDO)
            this.set1 = true;
            this.getAllContainersbyDoId(this.selectDO.id);
            this.getAllPickupDOContainers(this.requestId, this.selectDO.id)
            // this.getPortsByLocationId(this.selectDO.depot?.id);
            this.matColor = 'primary';
            this.pickupId = item.id;
            setTimeout(() => {
                document.getElementById('pickupForm').scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                });
            }, 200);
        }
    }

    container_nums_arr: any

    reviewData() {
        this.review = true;
        this.container_nums_arr = this.container_nums.split('\n')
        this.pickupObject.user_remark = this.remark;
        this.pickupObject.pickup_date = this.pick_up;
    }

    //get Release Order by requestID
    getReleaseorderbyReqID(id) {
        this.releaseservice.getReleaseOrderbyRequestId(id).subscribe({
            next: response => {
                this.releaseOrder = response;
                console.log("this is what i need", this.releaseOrder);
                this.cardLoader = false;
            },
        })
    }

    opendailog(container) {
        this.swapContainer = true;
        this.open = " sidepanel slidepanelOpen";
        this.Canvas = " Canvas setCanvas";
        this.containerSwapWith = container;
        console.log("this.containerSwapWith", this.containerSwapWith)
        console.log("review", this.review)

    }

    closedailog() {
        this.open = " sidepanel";
        this.Canvas = " Canvas ";
    }


    postDOContainerReference(data) {
        this.releaseservice.postDOcontainerReference(data).subscribe({
            next: response => {
                this.snackBar.open("Container Pick-up saved!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.markedPickup = true;
            },
        })
    }

    getDOContainerReference() {
        this.releaseservice.getDOcontainerReference().subscribe({
            next: response => {
                this.ContainerReference = response.results;
                console.log("this.DOContainerReference", this.ContainerReference)
            },
        })
    }

    getAllContainerPickup(id) {
        this.releaseservice.getAllPickupContainers(id).subscribe({
            next: response => {
                this.ContainerReference = response.results;
                console.log("this.DOContainerReference", this.ContainerReference)
            },
        })
    }

    getAllContainersbyDoId(id) {
        this.releaseservice.getAllContainersbyDoId(id).subscribe({
            next: response => {
                this.containerID = response.results;
            },
        })
    }

    openDialog(): void {
        const dialogData = {
            data: this.containerInfo,
            containerPickup: this.containerPickup
        };
        const dialogRef = this.dialog.open(SupplierPickupReturnContainersComponent, {
            width: '100%', // Set the width of the dialog
            disableClose: true,
            data: dialogData
        });

        // Optionally, you can subscribe to dialog close events
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // Handle "Yes" button click
                console.log('User clicked Yes');
            } else {
                // Handle "No" button click or dialog close
                // console.log('User clicked No or closed the dialog');
            }
        });

        dialogRef.componentInstance.pickupSaved.subscribe(() => {
            this.showPickup = true;
            this.pickupData = false;
            this.PickupContainer = false;
            this.firstPick = true;
            this.snackBar.open("Container Pick-up saved!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
            this.containerPickup = {...this.defaultContainer};
            this.containerInfo = [];
            this.refreshPickupList(this.requestService?.selectedRequest?.id);
            this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);
        });
    }

    refreshPickedupContainersList() {
        this.showPickup = true;
        this.containerPickup.container_numbers = '';
        this.containerPickup.pickup_date = null;
        this.containerPickup.remarks = '';
        this.refreshPickupList(this.requestService?.selectedRequest?.id);
        this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);
    }

    postDOContainerPickup(containerPickup) {
        this.disableValidateContainers = true;
        containerPickup['do'] = this.selectDO.id;
        let user_remark = containerPickup.remarks;
        let pickup_date = containerPickup.pickup_date;
        const splitArray = containerPickup['container_numbers'].split(/[,\n\s]+/);
        const uniqueArray = Array.from(new Set(splitArray));
        containerPickup['container_numbers'] = uniqueArray.join(", ");
        this.releaseservice.postDOContainerPickup(containerPickup).subscribe({
            next: response => {
                console.log('postDOContainerPickup', response);
                this.pickupObject.user_remark = user_remark;
                this.pickupObject.pickup_date = pickup_date;
                this.pickupObject.invoice_number = containerPickup.invoice_number;
                this.pickupObject.invoice_date = containerPickup.invoice_date;
                this.containerPickupResponse = response;
                this.containerInfo = response;
                this.openDialog();
                this.disableValidateContainers = false;
            },
            error: error => {
                this.disableValidateContainers = false;
                if (error.error.do?.length) {
                    this.openWarning(`${error.error.do[0]}`, '', 'I Understand');
                } else if (error.error.agg_container_numbers?.length) {
                    let containerNumbers = error.error.agg_container_numbers.map(item => `• ${item}`).join('\n');
                    this.openWarning(containerNumbers, '', 'I Understand');
                }
                return this.catchError(error);
            }
        })
        // this.getDOContainerReference();
    }

    getContainerPickupbyReqId(id) {
        this.releaseservice.getContainerPickupbyreqID(id).subscribe({
            next: response => {
                this.containerPickupData = response.results;
            },
        })
    }

    getContainerPickup(item) {
        this.getContainerPickupbyReqId(item.id);
    }

    // edit(item) {
    //     item.isEdit = true;
    // }

    edit(item, isSwap = false) {
        item.isEdit = !isSwap; // Enable edit mode only if NOT swapping
        item.isSwapMode = isSwap; // If swap button is clicked, enable swap mode
        // Store original container number
        item.original_container_number = item.container?.container_number;
        if (!isSwap) {
            item.originalData = { ...item };
        }
    }
    
    saveChanges(item, i) {
        if (item.isSwapMode) {
            this.swapContainers(item, i);
        } else {
            this.updateDOContainerPickup(item, i);
        }
        // item.isEdit = false; // Disable edit mode after saving
        // item.isSwapMode = false; // Reset swap mode
    }
    

    backtoList() {
        this.PickupContainer = false;
        this.firstPick = true;
        this.showPickup = true;
    }

    AddPickup() {
        this.PickupContainer = true;
        this.firstPick = false;

        this.showPickup = false;
        setTimeout(() => {
            document.getElementById('pickUpContainer').scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start"
            });
        }, 200);
    }

    updateDOContainerPickup(item, i) {
        console.log("Pickupobject", this.pickupObject, item)
        // item['do'] = this.selectDO.id;
        item['do'] = item?.do?.id;
        item['id'] = item.id;
        item['container'] = item.container.id
        item['current_status'] = item.current_status.id
        this.releaseservice.updateDOContainerReference(item).subscribe({
            next: response => {
                this.snackBar.open("Update Pick-up Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                // this.markedPickup = true;
                this.refreshPickupList(this.requestService?.selectedRequest?.id);
                this.requestDetailsBookingChargesService.bookingDetailsUpdated$.next(true);
            },
        })
        this.closedailog();
        // this.getContainerPickupbyDoId(this.releaseservice.selectedOrder.id)

    }

    deleteDOContainerPickup(item) {
        // this.pickupObject['do'] = this.selectDO.id;
        this.loading = true;
        this.pickupObject['do'] = item.do?.id;

        this.pickupObject['id'] = item.id;
        // this.pickupObject['is_active'] = false;
        this.releaseservice.deleteDOContainerReference(this.pickupObject).subscribe({
            next: response => {
                this.snackBar.open("Delete Pick-up Container Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                // this.markedPickup = true;
                this.loading = false;
                this.refreshPickupList(this.requestService?.selectedRequest?.id);
                this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);
                this.requestDetailsBookingChargesService.bookingDetailsUpdated$.next(true);
            },
        })
        // this.getReleaseorderbyReqID(this.releaseservice.selectedOrder.id);
        // this.getContainerPickupbyDoId(this.releaseservice.selectedOrder.id)
    }

    refreshPickupList(id, pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex
        this.releaseservice.getAllPickupContainers1(this.requestService?.selectedRequest?.id, pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                console.log("depot list", response)
                this.pickupList = new MatTableDataSource(response.results);
                console.log("this.pickupList", this.pickupList.data.length)
                if (this.pickupList.data.length > 1) {
                    // this.releaseservice.isShowRejectBooking = false;
                }
                this.pageLength = response.count;
                if (this.pageLength > 0) {
                    console.log(this.pageLength > 0, 'this.pageLength > 0');
                    this.billuLoader = false;
                    this.loading = false;
                }
                if (this.pageLength === 0) {
                    this.billuLoader = true;
                    if (searchTerm == '')
                        this.filterBoolean = false;
                    console.log(this.pageLength === 0, 'this.pageLength === 0');
                    this.part1 = 'No';
                    this.part2 = 'Pick-ups';
                    this.part3 = this.filterBoolean ? 'found' : 'yet';
                    this.loading = false;
                    this.filterBoolean = false;
                }

            }
        })
    }

    pageChanged(event: PageEvent) {
        this.loading = true;
        console.log({event});
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.refreshPickupList(this.requestService?.selectedRequest?.id);
    }

    filterBoolean = false;

    applyFilter(event) {
        this.loading = true;
        this.pageIndex = 0;
        this.filterBoolean = true;
        this.searchText.next(event);
    }

    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        }
    }

    //sorting pickup
    announceSortChange(sortState: Sort) {
        this.loading = true;
        switch (sortState.direction) {
            case 'asc':
                this.refreshPickupList(this.requestService?.selectedRequest?.id, this.pageSize, this.pageIndex, this.searchTerm, sortState.active);
                break;

            case 'desc':
                this.refreshPickupList(this.requestService?.selectedRequest?.id, this.pageSize, this.pageIndex, this.searchTerm, `-${sortState.active}`);
                break;

            default:
                this.refreshPickupList(this.requestService?.selectedRequest?.id, this.pageSize, this.pageIndex, this.searchTerm);
        }
    }

    navigatePickup() {
        this.router.navigateByUrl[''];
        this.navigatePickUp.emit('release_order');
    }

    getContainersList() {
        this.selectedContainers = [];
        // this.selectedContainers = '';
        this.containersListComponent.selection.selected.forEach((container: any) => {
            if (container.pickup_date == null)
                this.selectedContainers.push(container.id)
            // this.selectedContainers += (this.selectedContainers ? ',' : '') + container.id;

        });
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }

    postDOContainerPickupDetails() {
        this.disableValidateContainers = true;

        this.getContainersList();
        // const splitArray = this.selectedContainers['container_numbers'].split(/[,\n\s]+/);
        if (this.selectedContainers.length == 0) {
            this.openWarning('Please select at least one container which is yet not returned.', '', 'I Understand');
            return;
        }
        if (this.selectedContainers.length != 0) {
            console.log(this.selectedContainers);
            this.releaseservice
                .savePickupDetails(
                    this.selectedContainers,
                    this.containerPickup.pickup_date,
                    this.containerPickup.remarks,
                    this.selectDO.id,
                    this.containerPickup.port,
                    this.containerPickup.invoice_number,
                    this.containerPickup.invoice_date
                )
                .subscribe({
                    next: (response) => {
                        this.containerPickup = {...this.defaultContainer};
                        this.containerInfo = [];
                        this.refreshPickupList(this.requestService?.selectedRequest?.id);
                        this.getReleaseorderbyReqID(this.requestService?.selectedRequest?.id);

                        this.showPickup = true;
                        this.pickupData = false;
                        this.PickupContainer = false;
                        this.firstPick = true;
                        this.snackBar.open('Containers Pick-up Successfully!', 'Close', {
                            verticalPosition: 'top',
                            duration: 2000,
                        });
                        this.disableValidateContainers = false;
                        // console.log('post closed do container setting value true')
                        this.requestDetailsBookingChargesService.bookingDetailsUpdated$.next(true);
                    },
                    error: (error) => {
                        this.disableValidateContainers = false;
                        return this.catchError(error);
                    },
                });

        }
    }

    containerList: any;

    getAllPickupDOContainers(reqId, doId) {
        this.releaseservice.getAllPickupDOContainers(reqId, doId, 100).subscribe({
            next: response => {
                this.containerList = response.results;
            },
        })
    }

    getPortsByLocationId(id) {
        this.releaseservice.getPortsByLocationId(id).subscribe({
            next: response => {
                this.ports_url = response.results;
            },
        })
    }

    swapContainers(item, i) {
        // item['do'] = item?.do?.id;
        // item['id'] = item.id;
        // item['container'] = item.container.container_number
        // item['current_status'] = item.current_status.id
        let payload = {
            do_container_reference : item.id,
            container_number : item.container.container_number,
            remarks : item.swapping_remarks
        }
        this.releaseservice.swapContainer(payload).subscribe({
            next: response => {
                this.snackBar.open("Swap Container Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.refreshPickupList(this.requestService?.selectedRequest?.id);
                this.requestDetailsBookingChargesService.bookingDetailsUpdated$.next(true);
            },
            error: (error) => {
                this.catchErrors(error,i);
                // const errorObj = error.error;
                // let messages: string[] = [];
            
                // if (errorObj.container_number) {
                //     const containerErrors = Array.isArray(errorObj.container_number)
                //         ? errorObj.container_number
                //         : [errorObj.container_number];
                //         messages.push(`container_number: ${containerErrors}`);
                //     }
            
                // if (errorObj.remarks) {
                //     const remarksErrors = Array.isArray(errorObj.remarks)
                //         ? errorObj.remarks
                //         : [errorObj.remarks];
                //         messages.push(`remarks: ${remarksErrors}`);
                //     }
            
                // const finalMessage = messages.join('\n');
                // this.openWarning(finalMessage, '', 'I Understand');
            },
        })
        this.closedailog();
    }
    cancel(item) {
        this.refreshPickupList(this.requestService?.selectedRequest?.id);
        // item.isEdit = false;
        // item.isSwapMode = false;
    }
    errorObjs: any[] = [];

    catchErrors(error, index) {
        if (error.status >= 400) {
            this.errorObjs[index] = { ...error.error };
            console.error('Error at index', index, error);
        }
    }
}
